import React from 'react';
import { Col, Container, Row } from '@design-system-etat/dsfr-react';
import { API_GET_VISUALISER_DOCUMENT_UTILISATEUR } from '../../../../constants/apiUrls.constants';
import AffichageResponsive from '../../../../components/Commun/AffichageResponsive';
import BoutonPdfTelechargeable from '../../../../components/Commun/Fichier/BoutonPdfTelechargeable';

const GuideCreerCompte = () => {
    const nomFichier = 'document_manuel_creation_compte.pdf';
    const urlFichier =
        process.env.REACT_APP_API_DETENTEURS_URL +
        API_GET_VISUALISER_DOCUMENT_UTILISATEUR.concat(nomFichier);
    return (
        <>
            <AffichageResponsive
                composantDesktop={
                    <iframe
                        title="Guide utilisateur SIA"
                        className="iframe"
                        width="100%"
                        height="100%"
                        src={urlFichier}
                    />
                }
                composantMobile={
                    <Container>
                        <Row className="margin-top-lg position-relative">
                            <Col col={12}>
                                <BoutonPdfTelechargeable
                                    urlFichier={urlFichier}
                                    label="Télécharger le manuel de création de compte"
                                    titreFichier={nomFichier}
                                />
                            </Col>
                        </Row>
                    </Container>
                }
                pointDeRupture="lg"
            />
        </>
    );
};

export default GuideCreerCompte;
